import { render, staticRenderFns } from "./ergo-videos.vue?vue&type=template&id=46a95c00&"
import script from "./ergo-videos.vue?vue&type=script&lang=js&"
export * from "./ergo-videos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports